/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IMedia } from '../media-schema';
import { mediaSchema } from '../media-schema';

export const uploadMediaResponseSchema = createApiResponseSchema(
  mediaSchema,
) as import('zod').ZodSchema<IAPI<IMedia>>;

export type IUploadMediaResponse = IAPI<IMedia>;
